module.exports = __webpack_public_path__ + "static/media/cc-icon.63bf9f43.svg";